import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { firstValueFrom, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BasicAuth } from '../interfaces/basic-auth.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GenericLoginService {

  private readonly genericLoginState = signal<boolean | null>(null);
  private readonly genericLogin$ = toObservable(this.genericLoginState);
  constructor(private readonly httpClient: HttpClient) {
    const isAuthenticated = localStorage.getItem('isBasicAuthSuccess');
    if (isAuthenticated === 'true') {
      this.genericLoginState.set(true);
    }
  }

  getGenericLoginObservable(): Observable<boolean | null> {
    return this.genericLogin$;
  }

  openGenericLoginModal(): Promise<boolean> {
    this.genericLoginState.set(null);
    this.genericLoginState.set(false);
    return firstValueFrom(
      this.genericLogin$.pipe(filter((result): result is boolean => result !== null))
    );
  }

  triggerLogin() {
    localStorage.setItem('isBasicAuthSuccess', 'true');
    this.genericLoginState.set(true);
  }

  declineLogin() {
    this.genericLoginState.set(false);
  }

  /**
   * @description Temporary login for dev and int portals
   * @param username
   * @param password
   * @returns Observable
   */
  public basicAuthLogin(username: string, password: string): Observable<BasicAuth> {
    const url = environment.proxyEndpoint + '/auth/checkUserAccess'
    return this.httpClient.post<BasicAuth>(url,
      {"userName": username,"userPassword" :password}
    );
  }

}
